module.exports = __webpack_public_path__ + "img/menu.6cd8b849.svg";